"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementDeniedButton = exports.SettlementExpectedButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function SettlementExpectedButton({ is_withdraw, upd_time, }) {
    const { isFondeeDayLoaded, fondeeDayArr } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementFondeeDayState);
    const expectedFondeeDay = isFondeeDayLoaded
        ? (0, _1.getExpectedFondeeDay)({ fondeeDayArr, targetDate: upd_time, is_withdraw })
        : undefined;
    const [showExpectedDialog, setShowExpectedDialog] = (0, react_1.useState)(false);
    const openExpectedDialog = () => setShowExpectedDialog(true);
    const closeExpectedDialog = () => setShowExpectedDialog(false);
    (0, webview_app_1.useAABBDialogClose)({ open: showExpectedDialog, closeDialog: closeExpectedDialog });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(SettlementDetailButton, Object.assign({ onClick: openExpectedDialog, sx: { color: 'var(--gray-80)' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4" }, { children: t('정산 예정일') })), (0, jsx_runtime_1.jsx)(svgs_1.ChevronRightSvg, { css: { width: '24px', height: '24px' } })] })), (0, jsx_runtime_1.jsxs)(SettlementDetailDialog, Object.assign({ open: showExpectedDialog, onClose: closeExpectedDialog }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "settlement_detail_title subtitle3 gray-80" }, { children: t('정산 예정일') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "settlement_detail_content surface-table-row" }, { children: [expectedFondeeDay && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle4" }, { children: `~ ${expectedFondeeDay} ${t('오후 5시 정산 예정')}` }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "caption1 error-main" }, { children: [t('공휴일은 은행, 카드사가 쉬는 날이에요.'), (0, jsx_runtime_1.jsx)("br", {}), `${t('폰디 정산일도 함께 늦춰져요.')}🙇`] }))] })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ className: "settlement_detail_confirm", onClick: closeExpectedDialog }, { children: t('확인') }))] }))] }));
}
exports.SettlementExpectedButton = SettlementExpectedButton;
function SettlementDeniedButton({ isBalanceSettlement, reject_reason, }) {
    const [showDeniedDialog, setShowDeniedDialog] = (0, react_1.useState)(false);
    const openDeniedDialog = () => setShowDeniedDialog(true);
    const closeDeniedDialog = () => setShowDeniedDialog(false);
    (0, webview_app_1.useAABBDialogClose)({ open: showDeniedDialog, closeDialog: closeDeniedDialog });
    const { t } = (0, react_i18next_1.useTranslation)();
    const rejectReason = reject_reason || t('판매 링크와 함께 1:1문의하기로 방문해 주시면 도와드릴게요. 감사합니다!');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(SettlementDetailButton, Object.assign({ onClick: openDeniedDialog }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4 error-main" }, { children: t('정산 대기 사유') })), (0, jsx_runtime_1.jsx)(svgs_1.ChevronRightSvg, { css: { width: '24px', height: '24px', path: { stroke: 'var(--error-main)' } } })] })), (0, jsx_runtime_1.jsxs)(SettlementDetailDialog, Object.assign({ open: showDeniedDialog, onClose: closeDeniedDialog }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "settlement_detail_title subtitle3 error-main" }, { children: t('다시 접수해주세요!') })), isBalanceSettlement ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "balance_settlement_detail_content" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "naver_waybill_available surface-table-row" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.WarningTriangleRedSvg, { css: { width: '20px', height: '20px' } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4 gray-80" }, { children: t('네이버에서 운송장 조회 되시나요?') }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "caption1 gray-60" }, { children: [t('시스템에서 집화 처리되어야 정산 가능해요'), (0, jsx_runtime_1.jsx)("br", {}), "(=", t('택배 기사님께서 수거하는 시점'), ")"] }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "reject_detail body2 gray-80" }, { children: rejectReason }))] }))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "settlement_detail_content body2 gray-80 surface-table-row" }, { children: rejectReason }))), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ className: "settlement_detail_confirm", onClick: closeDeniedDialog }, { children: t('확인') }))] }))] }));
}
exports.SettlementDeniedButton = SettlementDeniedButton;
const SettlementDetailButton = (0, styled_1.default)(Button_1.default) `
  flex-shrink: 0;
  height: 32px;
  padding: 0 4px 0 12px;
  border-radius: 6px;
  border: 1px solid var(--gray-10);
  background-color: var(--white) !important;
`;
const SettlementDetailDialog = (0, styled_1.default)(Dialog_1.default) `
  .MuiPaper-root {
    row-gap: 14px;
    width: 335px;
    padding: 14px;
    border-radius: 12px;
    margin: 0;
    > * {
      flex-shrink: 0;
    }
    .settlement_detail_title {
      text-align: center;
    }
    .balance_settlement_detail_content {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      .naver_waybill_available {
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        padding: 12px 16px;
        border-radius: 8px;
      }
      .reject_detail {
        padding: 10px 0;
        white-space: pre-wrap;
      }
    }
    .settlement_detail_content {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      padding: 12px 14px;
      border-radius: 8px;
      white-space: pre-wrap;
    }
    .settlement_detail_confirm {
      height: 40px;
      border-radius: 8px;
      font-size: 15px;
      font-weight: bold;
      color: var(--white);
      background-color: var(--primary-main) !important;
    }
  }
`;
